import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BASE = 'https://line-ranger-guild-war.onrender.com';

const LINKS = [
  { section: 'ギルドウォー（本番）', items: [
    { path: '/guildWarNihonProd', label: 'にほーん 敵/味方デッキ' },
    { path: '/guildWarCMAProd', label: 'CMA 敵/味方デッキ' },
    { path: '/guildWarCaN', label: 'CaN 敵/味方デッキ' },
  ]},
  { section: '指示・戦略', items: [
    { path: '/guildWarInstructionsNihon', label: 'にほーん 指示生成' },
    { path: '/available-towers', label: '攻略可能タワー' },
    { path: '/guild-war-status-cma', label: 'CMA ステータス' },
  ]},
  { section: 'ランキング', items: [
    { path: '/guild-war-ranking-nihon', label: 'にほーん ランキング' },
    { path: '/guild-war-ranking-cma', label: 'CMA ランキング' },
    { path: '/guild-war-ranking', label: 'ランキング（全体）' },
  ]},
  { section: 'ギルド情報', items: [
    { path: '/guildInfoNihon', label: 'にほーん ギルド情報' },
    { path: '/guildInfoCma', label: 'CMA ギルド情報' },
    { path: '/guildInfoDreamTeam', label: 'ドリームチーム ギルド情報' },
    { path: '/guildInfo', label: 'ギルド情報（検索）' },
  ]},
  { section: 'レイド・守護者', items: [
    { path: '/raid-hitting-characters', label: 'レイド叩きキャラ' },
  ]},
  { section: 'その他', items: [
    { path: '/guildWarCount', label: 'ギルドウォー カウント' },
    { path: '/pvp', label: 'PvP ユニット' },
    { path: '/dreamTeam', label: 'ドリームチーム' },
    { path: '/rangers-book', label: 'レンジャーズブック' },
    { path: '/guild-war-predict', label: '対戦相手予測' },
    { path: '/access-logs', label: 'アクセスログ' },
  ]},
];

const InternalLinks = () => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [authError, setAuthError] = useState('');

  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    if (storedToken) {
      verifyToken(storedToken);
    } else {
      setIsLoading(false);
    }
  }, []);

  const verifyToken = async (token) => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        'https://rangers-api-3mfw.onrender.com/api/auth/verify-token',
        { token }
      );
      if (response.data.success) {
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem('authToken');
      }
    } catch (error) {
      localStorage.removeItem('authToken');
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setAuthError('');
    setIsLoading(true);
    try {
      const response = await axios.post(
        'https://rangers-api-3mfw.onrender.com/api/auth/verify-password',
        { password }
      );
      if (response.data.success) {
        localStorage.setItem('authToken', response.data.token);
        setIsAuthenticated(true);
      } else {
        setAuthError('パスワードが間違っています');
      }
    } catch (error) {
      setAuthError('パスワードが間違っているか、サーバーに接続できません');
    } finally {
      setIsLoading(false);
      setPassword('');
    }
  };

  if (isLoading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>読み込み中...</div>;
  }

  if (!isAuthenticated) {
    return (
      <div style={{ padding: '20px', maxWidth: '400px', margin: '0 auto', fontFamily: 'sans-serif' }}>
        <h1 style={{ fontSize: '1.4em' }}>内部リンク</h1>
        <form onSubmit={handlePasswordSubmit}>
          <label>パスワードを入力してください：</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ display: 'block', margin: '10px 0', padding: '8px', width: '100%' }}
          />
          <button type="submit" style={{ padding: '8px 16px' }}>送信</button>
          {authError && <p style={{ color: 'red', fontSize: '0.85em' }}>{authError}</p>}
        </form>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto', fontFamily: 'sans-serif' }}>
      <h1 style={{ fontSize: '1.4em', marginBottom: '20px' }}>内部リンク</h1>
      {LINKS.map(section => (
        <div key={section.section} style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '1em', color: '#555', borderBottom: '1px solid #ddd', paddingBottom: '4px', marginBottom: '8px' }}>
            {section.section}
          </h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {section.items.map(item => (
              <li key={item.path} style={{ marginBottom: '6px' }}>
                <a href={`${BASE}${item.path}`} style={{ color: '#0066cc', textDecoration: 'none', fontSize: '0.95em' }}>
                  {item.label}
                </a>
                <span style={{ color: '#999', fontSize: '0.75em', marginLeft: '8px' }}>{item.path}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default InternalLinks;
